/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, DoCheck, Input, signal} from "@angular/core";
import {FORM_CONTROL_IMPORTS} from './form-control-imports';

@Component({
  standalone: true,
  imports: FORM_CONTROL_IMPORTS,
  selector: 'message-dismisser',
  template: `<div *ngIf="visible" class="alert alert-success clickable" (click)="dismiss()" title="Click to dismiss message">{{message}}<span class="fa fa-times pull-right"></span></div>`
})
export class MessageDismisserComponent implements DoCheck {
  @Input() result: any;
  @Input() messageType: string;

  private readonly visibleState = signal(false);

  /**
   * result.data can flip true in a save then() during an existing CD turn
   * (modal close). Keep *ngIf stale until the next macrotask (NG0100).
   */
  get visible(): boolean {
    return this.visibleState();
  }

  get message(): string {
    if (this.messageType === 'creative') {
      return "Your creative updates were saved successfully";
    }
    if (this.messageType === 'productLayouts') {
      return "Your layout selections were updated successfully";
    }
    if (this.messageType === 'orderBudgets') {
      return "Your budget updates were saved successfully";
    }
    return "Your targeting updates were saved successfully";
  }

  dismiss(): void {
    if (this.result) {
      this.result.data = false;
    }
    this.visibleState.set(false);
  }

  ngDoCheck(): void {
    const visible = !!this.result?.data;
    if (visible !== this.visibleState()) {
      this.visibleState.set(visible);
    }
  }
}
